import { apiSlice } from "../../app/api/apiSlice";
import { Role } from "../../types/masterData";
import { RolesResponse, StatusResponse } from "../../types/response";
import { Status } from "../../types/user";

export const usersApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getRoles: builder.query<Role[], void>({
            query: () => '/api/tables/roles',
            transformResponse: (response: RolesResponse) => response.data,
            transformErrorResponse: (response) => response.data,
        }),

        // getSizes: builder.query<Size[], void>({
        //     query: () => '/api/tables/sizes',
        //     transformResponse: (response: SizesResponse) => response.data,
        //     transformErrorResponse: (response) => response.data,
        // }),
        
        getStatus: builder.query<Status[], void>({
            query: () => '/api/tables/status',
            transformResponse: (response: StatusResponse) => response.data,
            transformErrorResponse: (response) => response.data,
        })
    }),
});

export const {
    useGetRolesQuery,
    // useGetSizesQuery,
    useGetStatusQuery
} = usersApiSlice;;